import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-prompt-box',
    templateUrl: './prompt-box.component.html',
    styleUrls: ['./prompt-box.component.scss'],
    standalone: false
})
export class PromptBoxComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {}

}
